import { Link, useLocation } from 'react-router-dom'

interface MenuItem {
  path: string
  label: string
  icon: string
}

const menuItems: MenuItem[] = [
  { path: '/admin/dashboard', label: 'Dashboard', icon: '📊' },
  { path: '/admin/analytics', label: 'Statistiques', icon: '📈' },
  { path: '/admin/team', label: 'Équipe', icon: '👥' },
  { path: '/admin/news', label: 'Actualités', icon: '📰' },
  { path: '/admin/documents', label: 'Documents', icon: '📄' },
  { path: '/admin/gallery', label: 'Galerie', icon: '🖼️' },
  { path: '/admin/messages', label: 'Messages', icon: '✉️' },
  { path: '/admin/menus', label: 'Menus', icon: '🔗' },
  { path: '/admin/settings', label: 'Paramètres', icon: '⚙️' },
]

function Sidebar() {
  const location = useLocation()

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <h2>Admin</h2>
      </div>

      <nav className="sidebar-nav">
        <ul>
          {menuItems.map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                className={location.pathname === item.path ? 'active' : ''}
              >
                <span className="menu-icon">{item.icon}</span>
                <span className="menu-label">{item.label}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  )
}

export default Sidebar
